export default {
      id: "alert-usage",
      viewBox: "0 0 800 800",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#alert",
      toString: function () {
        return this.url;
      }
    }